export default "__VITE_ASSET__BPmcOxjg__"